// extracted by mini-css-extract-plugin
module.exports = {"inviteContainer":"inviteContainer--Pgtt3vde","inviteAddBtn":"inviteAddBtn--o6yOVNMl"};